export const CATEGORY_OPTIONS = [
  { code: 'HIDDEN_INSURANCE_MONEY', label: '숨은보험금찾기' },
  { code: 'COVERAGE_ANALYSIS', label: '보장분석' },
  { code: 'PRODUCT_AUTO', label: '자동차보험' },
  { code: 'PRODUCT_COMPREHENSIVE', label: '종합보험' },
  { code: 'PRODUCT_PENSION', label: '연금보험' },
  { code: 'PRODUCT_WHOLE_LIFE', label: '종신보험' },
  { code: 'PRODUCT_CARE', label: '간병보험' },
  { code: 'PRODUCT_FIRE', label: '화재보험' },
  { code: 'INSURANCE_REMODELING', label: '보험리모델링' },
  { code: 'PERSONAL_INTRO', label: '본인소개홈페이지' },
]

export const CATEGORY_OPTIONS_WITH_COMMON = [
  { code: 'ALL', label: '전체' },
  { code: 'COMMON', label: '공통' },
  ...CATEGORY_OPTIONS,
]

export function getCategoryLabel(category) {
  return CATEGORY_OPTIONS.find((item) => item.code === category)?.label || category || ''
}
